import { useCallback, useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';
var useDebouncedFunction = function (callback, delay) {
    var callbackRef = useRef(callback);
    useEffect(function () {
        callbackRef.current = callback;
    }, [callback]);
    var debouncedFunc = useCallback(debounce(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return callbackRef.current.apply(callbackRef, args);
    }, delay), [delay]);
    useEffect(function () { return function () {
        debouncedFunc.cancel();
    }; }, [debouncedFunc]);
    return debouncedFunc;
};
export default useDebouncedFunction;
